import { Component, OnInit } from '@angular/core';
import { CoreState } from "@core/store/core.reducers";
import { Store } from "@ngrx/store";
import { CoreActions } from "@core/store/core.actions";
import { fromEvent } from "rxjs";

@Component({
    selector: 'app-body',
    templateUrl: './body.component.html'
})
export class BodyComponent implements OnInit {
    constructor(private store: Store<CoreState>) { }

    ngOnInit(): void {
        this.setOnlineOfflineStatus();
    }

    private setOnlineOfflineStatus(): void {
        const callback = (isOnline: boolean): void => {
            this.store.dispatch(CoreActions.setIsOnline({ isOnline }))
        }

        fromEvent(window, 'online').subscribe(() => callback(true))
        fromEvent(window, 'offline').subscribe(() => callback(false))
        fromEvent(window, 'load').subscribe(() => callback(navigator.onLine))
    }

}
